import Grid from '@mui/material/Unstable_Grid2/Grid2'
import OneModal from "../OneModal/OneModal"
import { useState } from 'react'
import AudioOne from '../AudioOne/AudioOne'

const AudioModal = ({ open, setOpen, title, eventId = false, link = false }) => {
    const [loading] = useState(false)

    return (
        <>
            <OneModal
                open={open}
                setOpen={setOpen}
                titleText={title}
                loading={loading}
            >
                <Grid container sx={{ justifyContent: 'center', alignItems: 'center' }}>
                    <AudioOne src={link} title={title} />
                </Grid>
            </OneModal>
        </>
    )
}

export default AudioModal
